/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Gray_Opossum_DreamInputs */

const fr_born_gray_opossum_dream = /** @type {(inputs: Born_Gray_Opossum_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom d'utilisateur est obligatoire`)
};

/**

* @param {Born_Gray_Opossum_DreamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_gray_opossum_dream = /** @type {((inputs?: Born_Gray_Opossum_DreamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Gray_Opossum_DreamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_gray_opossum_dream(inputs)
});